import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  forwardRef,
} from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import {
  withStyles,
  makeStyles,
  ThemeProvider,
  createTheme,
} from '@material-ui/core/styles'
import {
  Search,
  Person,
  TodayOutlined,
  Today,
  Cancel,
} from '@material-ui/icons'
import axios from 'axios'
import MaterialTable, { MTableBodyRow } from 'material-table'
import { Skeleton, Alert } from '@material-ui/lab'
import { Button, Grid, Box, Dialog, TextField } from '@material-ui/core'
import Moment from 'moment'

import {
  cardBodyStyle,
  themeCss,
} from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const defaultMaterialTheme = createTheme(themeCss)

const useStyles2 = makeStyles({
  tableRow: { '&:hover': { backgroundColor: 'rgb(237, 247, 237)!important' } },
})

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

export default function ViewApplicantTest(props) {
  const classes = useStyles()
  const classes2 = useStyles2()

  const [rows, setRows] = useState([])
  const [loader, setLoader] = useState(true)
  const [error, setError] = useState(false)
  const [totalApplicants, setTotalApplicants] = useState(0)
  const [returnLogin, setReturnLogin] = React.useState(false)
  const [validateDateTest, setValidateDateTest] = useState(false)
  const [selectData, setSelectData] = useState([])
  const [errorDialog, setErrorDialog] = useState(false)
  const [mensajeDialog, setMensajeDialog] = useState('')
  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [openDesHabilitar, setOpenDesHabilitar] = useState(false)
  const [idRow, setIdRow] = useState('')
  const [openAlert, setOpenAlert] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [severity, setSeverity] = useState('success')

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  const [values, setValues] = useState({
    yearFrom: null,
    presentationDay: '',
    startTimeDay: '',
    endTimeDay: '',
    errorYearFrom: false,
    errorPresentationDay: false,
    errorStartTimeDay: false,
    errorEndTimeDay: false,
  })

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorStartTimeDay: false,
      errorEndTimeDay: false,
    })
  }

  const handleDateChangeFrom = (event) => {
    setValues({
      ...values,
      yearFrom: event ? event : null,
      presentationDay: event ? Moment(event).format('YYYY-MM-DD') : '',
      errorYearFrom: false,
    })

    setOpenAlertDialog(false)
  }

  const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  }

  const [state] = useState({
    columns: [
      {
        title: 'Nombres y apellidos',
        field: 'user.name',
        render: (rowData) => {
          return (
            <span>{rowData.user?.name + ' ' + rowData.user?.lastName}</span>
          )
        },
        width: '60%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 14,
        },
      },
      {
        title: 'Cédula',
        field: 'user.documentId',
        width: '10%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 14,
          textAlign: 'center',
        },
      },
      {
        title: 'Prueba',
        render: (rowData) => {
          return (
            <Fragment>
              <span style={{ fontSize: 12, fontWeight: 'bold' }}>
                {rowData.test?.name}
              </span>
            </Fragment>
          )
        },
        width: '30%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 14,
          // textAlign: 'center',
        },
      },
      {
        title: 'Fecha y Hora',
        render: (rowData) => {
          // Verificar si todos los campos están vacíos
          if (
            !rowData.presentationDay &&
            !rowData.startTimeDay &&
            !rowData.endTimeDay
          ) {
            return null // Retorna null para no renderizar nada
          }

          // Formatea la fecha (si es string como "25-08-05" o "2025-08-05")
          const formattedDate = Moment(
            rowData.presentationDay,
            'YYYY-MM-DD'
          ).isValid()
            ? Moment(rowData.presentationDay).format('DD-MM-YYYY')
            : rowData.presentationDay
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px', // Espacio entre elementos
              }}
            >
              <div style={{ fontSize: 10, color: 'green', fontWeight: 'bold' }}>
                Fecha: {formattedDate}
              </div>
              <div style={{ fontSize: 10, color: 'green', fontWeight: 'bold' }}>
                Hora inicio:{' '}
                {Moment(rowData.startTimeDay, 'HH:mm:ss').format('HH:mm')} Hora
                fin: {Moment(rowData.endTimeDay, 'HH:mm:ss').format('HH:mm')}
              </div>
            </div>
          )
        },
        width: '30%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 14,
          //  textAlign: 'center',
        },
      },
      {
        title: '-',
        field: 'status',
        render: (rowData) => {
          return props.status === 2 ? (
            ''
          ) : (
            <Button
              variant="contained"
              style={{
                fontSize: 10,
                background: 'orange',
                color: '#fff',
                fontWeight: 'bold',
                padding: '4px 10px',
              }}
              endIcon={<TodayOutlined />}
              onClick={changeDateValue(rowData)}
            >
              Cambiar fecha y hora
            </Button>
          )
        },
        width: '5%',
        cellStyle: {
          // whiteSpace: "nowrap",
          textAlign: 'CENTER',
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 10,
        },
      },
    ],
  })

  useEffect(() => {
    if (props.refresh) {
      TableData()
      props.refreshReturn()
    } else {
      TableData()
    }
  }, [props.refresh])

  const TableData = () => {
    axios
      .get(`${urlServices}tests-users/test/${props.jobsId.id}`, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then((response) => {
        const filterData = response.data.filter((val) => val.status !== 0)
        setTotalApplicants(filterData.length)
        setRows(filterData)
        setLoader(false)
      })
      .catch((e) => {
        if (e.response.status === 404) {
          setRows([])
          setLoader(false)
        } else if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          setRows([])
          setError(true)
          console.log(e)
        }
      })
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  const changeDateValue = (data) => () => {
    setSelectData(data)
    setValidateDateTest(true)
    setValues({
      ...values,
      presentationDay: '',
      startTimeDay: '',
      endTimeDay: '',
    })
    setOpenAlertDialog(false)
  }

  const submitSave = async () => {
    setOpenAlertDialog(false)
    let n = 0

    if (values.presentationDay === '') {
      setValues({ ...values, errorPresentationDay: true })
      setMensajeDialog('El campo "Fecha" es obligatorio.')
      setOpenAlertDialog(true)
      setErrorDialog('error')
      return
    }

    if (values.startTimeDay === '') {
      setValues({ ...values, errorStartTimeDay: true })
      setMensajeDialog('El campo "Hora de inicio" es obligatorio.')
      setOpenAlertDialog(true)
      setErrorDialog('error')
      return
    }

    if (values.endTimeDay === '') {
      setValues({ ...values, errorEndTimeDay: true })
      setMensajeDialog('El campo "Hora fin" es obligatorio.')
      setOpenAlertDialog(true)
      setErrorDialog('error')
      return
    }

    const dataValues = {
      presentationDay: values.presentationDay, // Ya en formato YYYY-MM-DD
      startTimeDay: formatTime(values.startTimeDay), // En formato HH:MM:SS
      endTimeDay: formatTime(values.endTimeDay), // En formato HH:MM:SS
    }

    await axios
      .put(`${urlServices}tests-users/${selectData.id}`, dataValues, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then((response) => {
        //setRows([])
        TableData()
        setMensajeDialog('Cambio con éxito.')
        setOpenAlertDialog(true)
        setErrorDialog('success')
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          console.log(e)
        }
      })
  }

  const handleEnable = () => () => {
    const dataValue = {
      status: 0,
    }

    axios
      .put(`${urlServices}tests-users/${idRow.id}`, dataValue, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then((response2) => {
        setMensaje('Registro eliminado con éxito.')
        setSeverity('success')
        setOpenAlert(true)
        TableData()
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          setMensaje('Error al registrar!!')
          setSeverity('error')
        }
      })
  }

  const validateTimeFormat = (time) => {
    const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
    return timeRegex.test(time)
  }

  const handleCloseDialog = (pro) => (event) => {
    props.exit()
  }

  const handleCloseDesHabilitar = () => () => {
    setOpenDesHabilitar(false)
  }

  const handleCloseDialogChangeDate = () => () => {
    setValidateDateTest(false)
  }

  // Formatear horas de "8:00" a "08:00:00"
  const formatTime = (time) => {
    if (!time) return '00:00:00'
    const [hours, minutes] = time.split(':')
    return `${hours.padStart(2, '0')}:${(minutes || '00').padStart(2, '0')}:00`
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        style={{ zIndex: 100 }}
        //scroll="body"
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid container spacing={1} className={classes.containerProfile}>
            {error && (
              <Grid item xs={12} sm={12}>
                <Alert severity="error">
                  Error en la consulta con sel servidor.
                </Alert>
              </Grid>
            )}
            {loader ? (
              <Grid item xs={12} sm={12}>
                <Box sx={{ width: '100%' }}>
                  <Skeleton width="100%" height={300} />
                </Box>
              </Grid>
            ) : (
              <Fragment>
                <Grid item xs={12} sm={12}>
                  <Alert
                    severity="success"
                    icon={<Person fontSize="inherit" />}
                  >
                    <b>
                      CANDIDATO{totalApplicants > 1 ? 'S' : ''} ASIGNADO
                      {totalApplicants > 1 ? 'S' : ''} CON PRUEBAS
                      <span style={{ marginLeft: 5, fontSize: 12 }}>
                        (Total registro: {totalApplicants})
                      </span>
                    </b>
                  </Alert>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <MaterialTable
                    title=""
                    columns={state.columns}
                    style={{
                      boxShadow: 'unset',
                      border: '1px solid rgb(241, 241, 241)',
                    }}
                    data={rows}
                    localization={{
                      toolbar: {
                        // nRowsSelected: '{0} row(s) selected',
                        searchTooltip: 'Filtrar',
                        searchPlaceholder: 'Buscar',
                      },
                      pagination: {
                        labelRowsSelect: 'Filas',
                        labelDisplayedRows: ' {from}-{to} de {count}',
                        firstTooltip: 'Primera página',
                        previousTooltip: 'Previo',
                        nextTooltip: 'Siguiente',
                        lastTooltip: 'Ultima página',
                      },
                      header: {
                        actions: ' - ',
                      },
                      body: {
                        emptyDataSourceMessage: 'No hay datos.',
                        filterRow: {
                          filterTooltip: 'Filtro',
                        },
                      },
                    }}
                    actions={[
                      (rowData1) => ({
                        icon: () => <Cancel />,
                        tooltip: 'Eliminar',
                        onClick: (event, rowData) => {
                          setOpenDesHabilitar(true)
                          setOpenAlert(false)
                          setIdRow(rowData)
                        },
                        hidden: rowData1.status === 1 ? false : true,
                      }),
                    ]}
                    icons={tableIcons}
                    options={{
                      search: true,
                      padding: 1,
                      filtering: false,
                      actionsColumnIndex: -1,
                      pageSize: 10,
                      headerStyle: {
                        background: '#F2F2F2',
                        padding: '1%',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      },
                      cellStyle: { border: '1px solid #DDDDDD' },
                    }}
                    components={{
                      Row: (props) => (
                        <MTableBodyRow
                          className={classes2.tableRow}
                          {...props}
                        />
                      ),
                    }}
                  />
                </Grid>
              </Fragment>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.buttonRight}
            onClick={handleCloseDialog(true)}
            style={{ marginRight: 25 }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      {/* ################## DIALOG CHANGE DATE ########## */}
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialogChangeDate()}
        aria-labelledby="customized-dialog-title"
        open={validateDateTest}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <MuiDialogContent dividers>
          <div className={classes.cardBrancheViewTitle} style={{ padding: 20 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>
                  Agregar la nueva fecha y hora
                </div>
                <div className={classes.lineBottom}></div>
                <Alert severity="info">
                  Fecha y hora que se activará la prueba.
                </Alert>
              </Grid>
              <Grid xs={12} md={8}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <KeyboardDatePicker
                      id="date-picker-dialog"
                      label="Desde"
                      onChange={handleDateChangeFrom}
                      value={values.yearFrom}
                      format="yyyy-MM-dd"
                      // views={["year"]}
                      animateYearScrolling={true}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      variant="inline"
                      keyboardIcon={<Today className={classes.iconTheme} />}
                      autoComplete="off"
                      //InputProps={{ readOnly: true }}
                      autoOk
                      //minDate={new Date()}
                      minDateMessage={false}
                      maxDateMessage={false}
                      error={values.errorYearFrom}
                    />
                  </ThemeProvider>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="startTimeDay"
                  value={values.startTimeDay}
                  error={
                    values.errorStartTimeDay ||
                    (!validateTimeFormat(values.startTimeDay) &&
                      values.startTimeDay)
                  }
                  onChange={handleChange('startTimeDay')}
                  fullWidth
                  required
                  label="Hora de inicio (HH:MM)"
                  margin="dense"
                  autoComplete="off"
                  placeholder="Ej: 08:00"
                  helperText={
                    !validateTimeFormat(values.startTimeDay) &&
                    values.startTimeDay
                      ? 'Formato inválido. Use HH:MM'
                      : ''
                  }
                  inputProps={{
                    pattern: '([01]?[0-9]|2[0-3]):[0-5][0-9]',
                    title:
                      'Por favor ingrese la hora en formato HH:MM (ej: 08:00)',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="endTimeDay"
                  value={values.endTimeDay}
                  error={
                    values.errorEndTimeDay ||
                    (!validateTimeFormat(values.endTimeDay) &&
                      values.endTimeDay)
                  }
                  onChange={handleChange('endTimeDay')}
                  fullWidth
                  required
                  label="Hora fin (HH:MM)"
                  margin="dense"
                  autoComplete="off"
                  placeholder="Ej: 17:00"
                  helperText={
                    !validateTimeFormat(values.endTimeDay) && values.endTimeDay
                      ? 'Formato inválido. Use HH:MM'
                      : ''
                  }
                  inputProps={{
                    pattern: '([01]?[0-9]|2[0-3]):[0-5][0-9]',
                    title:
                      'Por favor ingrese la hora en formato HH:MM (ej: 17:00)',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} style={{ marginTop: 3 }}>
                <center>
                  <Button
                    className={classes.buttonSubmit2}
                    onClick={submitSave}
                  >
                    Actualizar
                  </Button>
                </center>
                {openAlertDialog && (
                  <Alert
                    severity={errorDialog === 'error' ? 'error' : 'success'}
                    style={{ marginTop: 5 }}
                  >
                    {mensajeDialog}
                  </Alert>
                )}
              </Grid>
            </Grid>
          </div>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button
            className={classes.buttonRight}
            onClick={handleCloseDialogChangeDate()}
            style={{ marginRight: 25 }}
          >
            Cerrar
          </Button>
        </MuiDialogActions>
      </Dialog>

      {/* ################## DIALOG DELETE ########## */}
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDialogChangeDate()}
        aria-labelledby="customized-dialog-title"
        open={openDesHabilitar}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <MuiDialogContent dividers>
          <Grid container>
            {!openAlert ? (
              <>
                <Grid item xs={12} md={12} style={{ paddingTop: 30 }}>
                  <center>
                    <Cancel style={{ fontSize: 50, color: 'ref' }} />
                    <br></br>
                    <div className={classes.titleCardFilter}>
                      ¿Desea ELIMINAR este registro?
                    </div>
                    <Alert severity="error">
                      Se eliminará permanentemente.
                    </Alert>
                  </center>
                </Grid>
                <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
                  <center>
                    <Button
                      className={classes.buttonSubmit2}
                      onClick={handleEnable()}
                    >
                      Eliminar
                    </Button>
                  </center>
                </Grid>
              </>
            ) : (
              <Grid item xs={12} md={12}>
                <Alert severity={severity === 'error' ? 'error' : 'success'}>
                  {mensaje}
                </Alert>
              </Grid>
            )}
          </Grid>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button
            className={classes.buttonRight}
            onClick={handleCloseDesHabilitar()}
            style={{ marginRight: 25 }}
          >
            Cerrar
          </Button>
        </MuiDialogActions>
      </Dialog>
    </>
  )
}
